import { useDataSubmit } from 'Simple/Data.js'
export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'payers',
    viewPath: props.viewPath,
  })
  return function onClick() {
    submit({ type: 'downpayment_skip' })
  }
}
